import _asyncToGenerator from "C:/GitLab-Runner/builds/VgMjNYji/0/billing/billingmalta/src/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { EventEmitter } from '@angular/core';
import { EntityQuery } from '@cime/breeze-client';
import { BreezeViewService } from '@common/services/breeze-view.service';
import _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@angular/common";
import * as i3 from "@fortawesome/angular-fontawesome";
import * as i4 from "@ng-bootstrap/ng-bootstrap";
const _c0 = function (a0) {
  return {
    "background-color": a0
  };
};
function BookmarkComponent_ng_template_3_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 6);
    i0.ɵɵlistener("click", function BookmarkComponent_ng_template_3_div_0_Template_div_click_1_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r6);
      const color_r4 = restoredCtx.$implicit;
      const ctx_r5 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r5.clickColor(color_r4.value));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const color_r4 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c0, color_r4.value));
  }
}
function BookmarkComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, BookmarkComponent_ng_template_3_div_0_Template, 2, 3, "div", 5);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r2.colors);
  }
}
const _c1 = function (a0, a1) {
  return {
    color: a0,
    opacity: a1
  };
};
export class BookmarkComponent {
  constructor(breezeViewService) {
    this.breezeViewService = breezeViewService;
    this.defaultColor = '#b8c7ce';
    this.disabled = false;
    this.setColor = new EventEmitter();
    this.clickColor = _.debounce(this.clickColor.bind(this), 50);
  }
  shorten(input, number = 2) {
    return input.substring(0, number).toLowerCase();
  }
  queryColorsAndOpenPopover(popover) {
    var _this = this;
    return _asyncToGenerator(function* () {
      const query = new EntityQuery('Colors').withParameters({
        $method: 'POST',
        $data: {}
      });
      const data = yield _this.breezeViewService.entityManager.executeQuery(query);
      _this.colors = data.results;
      popover.open();
    })();
  }
  clickColor(colorId) {
    this.setColor.emit({
      entityId: this.entityId,
      colorId
    });
  }
}
BookmarkComponent.ɵfac = function BookmarkComponent_Factory(t) {
  return new (t || BookmarkComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService));
};
BookmarkComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: BookmarkComponent,
  selectors: [["app-bookmark"]],
  inputs: {
    color: "color",
    entityId: "entityId",
    entity: "entity",
    disabled: "disabled"
  },
  outputs: {
    setColor: "setColor"
  },
  decls: 5,
  vars: 5,
  consts: [["popoverClass", "box-shadow", "placement", "right", "container", "body", "triggers", "manual", 1, "marker", 3, "ngStyle", "ngbPopover", "click"], ["popover", "ngbPopover"], ["icon", "bookmark"], ["class", "colorpicker"], ["colorpicker", ""], [4, "ngFor", "ngForOf"], [1, "color", 3, "ngStyle", "click"]],
  template: function BookmarkComponent_Template(rf, ctx) {
    if (rf & 1) {
      const _r7 = i0.ɵɵgetCurrentView();
      i0.ɵɵelementStart(0, "div", 0, 1);
      i0.ɵɵlistener("click", function BookmarkComponent_Template_div_click_0_listener() {
        i0.ɵɵrestoreView(_r7);
        const _r0 = i0.ɵɵreference(1);
        return i0.ɵɵresetView(!ctx.disabled && ctx.queryColorsAndOpenPopover(_r0));
      });
      i0.ɵɵelement(2, "fa-icon", 2);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(3, BookmarkComponent_ng_template_3_Template, 1, 1, "ng-template", 3, 4, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      const _r1 = i0.ɵɵreference(4);
      i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(2, _c1, ctx.color, ctx.color === ctx.defaultColor ? "20%" : "100%"))("ngbPopover", _r1);
    }
  },
  dependencies: [i2.NgForOf, i2.NgStyle, i3.FaIconComponent, i4.NgbPopover],
  styles: [".marker {\n  display: inline-block;\n  vertical-align: baseline;\n  font-size: inherit;\n  cursor: pointer;\n}\n.marker:hover {\n  opacity: 100% !important;\n}\n\n.popover-body {\n  height: 1.463rem;\n  border-radius: 0.2926rem;\n  padding: 0;\n}\n.popover-body .ng-star-inserted {\n  display: inline-block;\n}\n.popover-body .ng-star-inserted .color {\n  height: 1.463rem;\n  width: 1.463rem;\n  cursor: pointer;\n  -webkit-user-select: none;\n          user-select: none;\n  font-weight: 600;\n  color: #f1f1f1;\n}\n.popover-body .ng-star-inserted .color:active {\n  box-shadow: inset 0 0 1.463rem 0 #2c3b41;\n  color: #2c3b41;\n}\n.popover-body .ng-star-inserted:first-of-type .color {\n  border-top-left-radius: 0.2926rem;\n  border-bottom-left-radius: 0.2926rem;\n}\n.popover-body .ng-star-inserted:last-of-type .color {\n  border-top-right-radius: 0.2926rem;\n  border-bottom-right-radius: 0.2926rem;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
  encapsulation: 2
});